export default {
  name: 'virtualmotorcyclespeedway',
  maxRacerNumber: 4,
};
